<template>
  <div>
    <Breadcrumb :options="breadcrumb" />
    
    <div class="mainss">
      <div class="left">
        <div class="card">
          <div class="img">
            <el-image :src="imageUrl"></el-image>
          </div>
          <el-form ref="form" :model="form" :rules="rules">
            <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="onSubmit">确认提交</el-button>
        </div>
      </div>
      <div class="right">
        <div class="title">建议记录</div>
        <div class="cont">
          <el-steps direction="vertical">
            <el-step :title="c.addtime" v-for="(c, i) in remarks" :key="'remark' + i">
              <template slot="description">
                <div class="cons">
                  <div class="tit">{{ c.title }}</div>
                  <div class="word">
                    {{ c.content }}
                  </div>
                  <div class="img">
                    <el-image v-for="(v, j) in c.photo" :key="'img' + j" :src="v.url"
                      :preview-src-list="c.photo.map(v => v.url)"></el-image>
                  </div>
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'feedback',
      breadcrumb: [
        { name: "帮助中心", path: `` },
        { name: "改进建议" },
      ],
      imageUrl: require('../../../assets/banner_improve.png'),
      form: {
        title: undefined,
        content: undefined,
        name: undefined,
        tel: undefined,
      },
      formCtrl: [
        {
          label: "建议标题",
          keyName: "title",
          err: "请填写建议标题",
          type: "text",
        },
        {
          label: "详细描述",
          keyName: "content",
          err: "请填写详细描述",
          type: "textarea",
        },
        {
          label: "您的姓名",
          keyName: "name",
          err: "请填写您的姓名",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "tel",
          err: "请填写联系电话",
          type: "number",
        },
        {
          label: "上传图片",
          keyName: "photo",
          type: "file",
          ptype: "feedback",
        },
      ],
      rules: {
        title: [
          { required: true, message: "请填写建议标题", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请填写详细描述", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请填写您的姓名", trigger: "blur" },
        ],
        tel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
      },
      getOptionUrl: 'index',
      remarks: [],
      submitUrl: 'updatexinyang',
    };
  },
  methods: {
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/rec`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ data }) => {
        if (data) {
          this.remarks = data
          // console.log('有数据了', data.tradeid, typeof data.tradeid)
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    submitReq(data) {
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        // userid: this.user.id,
      }
      this.paramsPackage(params, this.form)
      if (this.id && this.mode === 'edit') {
        params['id'] = this.id
      }
      // console.log(data)
      if (typeof data === 'object') {
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            params[key] = data[key];
          }
        }
      }
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.form = { tel: null, remarks: null, photo: null }
          this.$forceUpdate()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
        this.$nextTick(() => {
          this.getData(this.id);
          this.form.remarks = undefined
        })
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.form.id = this.id
    this.getData()
  },
};
</script>

<style lang="less" scoped>
.mainss {
  display: flex;
  justify-content: space-between;

  .left {
    width: 48%;
    margin-right: 20px;

    >.card {
      background-color: #fff;
      padding: 40px;
      border-radius: 5px;
      box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

      .img {
        margin-bottom: 40px;
      }
      /deep/.el-form-item__error {
        left: 75px;
      }
    }
  }

  .right {
    width: 48%;
    padding: 40px 0 40px 40px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.03);
    border-radius: 5px;

    >.title {
      font-weight: bold;
      font-size: 17px;
      color: #303133;
      height: 22px;
      line-height: 22px;
      margin-bottom: 30px;
    }
  }

  /deep/.el-steps {
    .el-step__description {
      padding-right: 0;
    }

    .el-steps--vertical {
      height: 180%;
    }

    .el-step__icon.is-text {
      background: #2691FF;
      border: 0;
    }

    .el-step__icon {
      width: 12px;
      height: 12px;
    }

    .is-vertical .el-step__line {
      width: 2px;
      top: 15px;
      bottom: 0px;
      left: 5px;
    }

    .el-step__line {
      background: #E6E8EB;
    }

    .el-step__icon-inner {
      display: none;
    }

    .is-vertical .el-step__head {
      padding-top: 4px;
      flex-grow: 0;
      width: 14px;
    }

    .el-step__title {
      font-size: 15px;
      font-weight: 400;
      color: #303133;
    }
  }

  .cons {
    width: 90%;
    margin: 10px 0;
    padding: 15px 20px;
    background: #F7F7F7;
    border-radius: 5px;
    opacity: 1;

    .tit {
      font-size: 15px;
      font-weight: 400;
      color: #909399;
    }

    .word {
      margin-top: 10px;
      font-size: 14px;
      font-weight: 400;
      color: #303133;
    }

    .img {
      margin-top: 10px;
      width: 92px;
      // height: 92px;
    }
  }
}

/deep/.el-form {

  .el-form-item {
    padding: 0 20px 15px 0;

    .el-input {
      width: 100%;
    }
  }

  .el-form-item {
    margin-bottom: 5px;
  }

  .el-textarea__inner {
    height: 100px;
    font-family:"Microsoft Yahei";
  }
}

.btns {
  margin: 30px 0 30px 108px;
}
</style>
